import { matchPath } from 'react-router'
import useNavigation from 'core/hooks/navigation/useNavigation'

const useUrlProgramId = (): string => {
  const { pathname } = useNavigation()
  const m = matchPath('/team/:token_id/program/:program_id/*', pathname)
  return m?.params?.program_id ?? ''
}

export default useUrlProgramId
